import { ShowOnLargeScreen } from 'components/Layout';
import { Flex, Text } from 'roo-ui/components';
import { ListBooking } from 'types';

interface StayInfoProps {
  booking: ListBooking;
}

export const StayInfo = ({ booking }: StayInfoProps) => {
  const { totalGuests, formattedCheckIn, formattedCheckOut } = booking.reservation;

  return (
    <Flex flexDirection={['column', 'row']} mt={4}>
      <Text color="greys.steel" fontSize={16}>
        {formattedCheckIn} - {formattedCheckOut}
      </Text>
      <ShowOnLargeScreen>
        <Text px={1}> • </Text>
      </ShowOnLargeScreen>
      <Text color="greys.steel" fontSize={16}>
        {totalGuests} guests
      </Text>
    </Flex>
  );
};
